export const Application = {
  ONLINE: 'online',
  CONTACT_CENTER: 'contactcenter',
};

export const sendEmailModalContent = {
  SEND_EMAIL_IMAGE:
    'https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/images/man-and-woman-with-laptop.svg',
  SEND_QUOTE_TO_EMAIL: 'Send quote to email',
  EMAIL_MOBILE_NOTE:
    'This email address and mobile number is linked to this application. We’ll use these details to confirm your identity and keep your information secure.',
  APPLICATION_SAVED_SUCCESSFULLY:
    'Thank you, your application was successfully saved and your application reference number is ',
  APPLICATION_REFERENCE: 'Your application reference number is',
  APPLICATION_ACCESS: 'You must have this number to access your application',
  APPLICATION_RETRIEVE:
    "Your application will be saved for 30 days. You'll need this reference number and mobile number to retrieve the application.",
  QUERY_CONTACT_US:
    'In the meantime, if you have queries related to your application, contact us on',
  DUTY_NOTE:
    "to take reasonable care not to make a misrepresentation still applies until you purchase a policy. When re-accessing your application you must ensure the answers you provided are accurate and not misleading, and you must update any information which has changed since starting your application. We'll ask you to confirm if there have been any changes to your answers.",
  REACCESSING_APPLICATION_NOTE:
    'When re-accessing your application you must ensure the answers you provided are accurate and not misleading, and you must update any information which has changed since starting your application. We will ask you to confirm if there have been any changes to your answers.',
  DONE: 'Done!',
  QUOTE_SENT_TO: 'You have asked for your quote to be sent to:',
  QUOTE_EMAILED: 'Thank you. Your quote has been emailed to you.',
  QUOTE_RETRIEVE_NOTE:
    "The email also contains a link to help you retrieve your application. Your application will be saved for 30 days. You'll need your application reference number and mobile number to retrieve the application.",
  QUOTE_CONTACT_US:
    'In the meantime, if you have queries related to your application, contact us on',
};

//* BELOW = Age is below 65 for full 5 year projection
//* WITHIN = Age will be over 65 within the 5 year projection (Starts off below 65)
//* ABOVE = Age 65 at purchase date
export const AGE_RANGE = {
  BELOW: 'BELOW_SIXTY_FIVE_ONLINE',
  WITHIN: 'WITHIN_SIXTY_FIVE_ONLINE',
  ABOVE: 'OVER_SIXTY_FIVE_ONLINE',
  WITHIN_CC: 'WITHIN_PROJECTED_AGE_RANGE_CONTACT_CENTER',
  ABOVE_CC: 'OVER_SIXTY_FIVE_CONTACT_CENTER',
};

export const OUTCOME_STAGE = {
  NB: 'New Business',
  QT: 'Quote ',
};

export const POLICY_OUTCOME = {
  P: 'Provisional',
  Y: 'Success',
  R: 'Referral',
  D: 'Decline',
  A: 'Accepted',
  C: 'Complete',
  U: 'Upgrade',
};

export const AURA_OUTCOME = {
  ACC: 'Accepted',
  RUW: 'Referral',
  DCL: 'Decline',
  PP: 'Postpone',
  NONE: 'None',
};

export const AURA_STATEMENT = {
  MEDICAL_STATEMENT_EVER: 'Have you EVER had, been diagnosed with or taken treatment for:',
  MEDICAL_STATEMENT_LAST_5YEARS:
    'In the last 5 years have you had, been diagnosed with or taken treatment for:',
  AURA_ERROR_MESSAGE: 'An error has ocurred while submitting the request, please try again',
};

export const AURA_QUESTION = {
  AURA_QUESTION_NAME: 'healthQuestion',
  AURA_BP_SYSTOLIC_READING: 'systolicReading',
  AURA_BP_DIASTOLIC_READING: 'diastolicReading',
  AURA_BLOOD_PRESSURE: 'BLOOD_PRESSURE',
  AURA_BP_SYSTOLIC: 'systolic',
  AURA_BP_DIASTOLIC: 'diastolic',
  AURA_UNITIZED: 'UNITIZED',
  AURA_UNITIZED_VALUE: 'unitizedValue',
  AURA_UNITIZED_OPTION: 'unitizedOption',
  AURA_NOT_IN_LIST: 'Not in List',
};

export const AURA_VALIDATION_MESSAGES = {
  FIELD_REQUIRED: 'This field is required',
  VALID_DATE: 'Please enter a valid date',
  ALPHA_NUMERIC_FIELD:
    "Only alphanumeric characters and special character  ( ) : ; , . ? ' are allowed",
};

export const optVerificationModalContent = {
  ALLIANZ_INFORMATION: 'Allianz securely manages your information',
  MOBILE_NUMBER_OTP:
    'This mobile number is linked to your life insurance quote. To keep your information secure, we’ll be using this number to send you a verification code when you proceed or retrieve your saved application.',
  SEND_CODE_SMS: 'SEND CODE VIA SMS',
  SMS_SEND_WAIT: 'An SMS message was recently sent. Please wait 30 seconds before trying again.',
  GENERIC_SMS_ERROR: 'Unable to send sms request, please try again later.',
  ENTER_CODE: 'Enter the code we have sent to',
  RESEND_SMS_CODE:
    'A new code has been sent to your mobile number. Allow 30 seconds before you attempt to send another code.',
  DIDNT_RECIEVE_CODE: 'Didn’t receive a code?',
  RESEND_CODE_PHONE: 'RESEND CODE TO MY PHONE',
  OTP_VERIFICATION_FAILED:
    "The code you've entered is either incorrect or your session timed out. Enter the numerical verification code we’ve sent to you via SMS or select the option below to resend a verification code again and enter the details above.",
  GENERIC_CODE_VERIFICATION_ERROR:
    'Some error occurred while verifying the OTP, please try again later.',
  HELP_CONFIRM_IDENTITY: 'Help us confirm your identity',
};

export const ccRetrieveContent = {
  RETRIEVE_APPLICATION: 'Retrieve your Life Insurance application',
  ENTER_DETAILS: 'Please enter the following details:',
  FILTER_CRITERIA:
    'Enter as Reference Number only OR Date of Birth only OR Mobile, Surname and Date of Birth',
  SEARCH_NO_RESULT: 'No matching application found. Re-enter your details and try again.',
  CONTINUE: 'Continue',
  SEARCH_RESULTS: 'Search results',
  ALLIANZ: 'Allianz',
  NO_DATA_AVAILABLE: 'No data available',
  CANCEL: 'CANCEL',
  REF_NO: 'RefNo',
  INSURED_NAME: 'Insured Name',
  DOB: 'DOB',
  START_DATE: 'Start Date',
  SOURCE: 'Source',
  INTERMEDIARY: 'Intermediary',
  ACCOUNT: 'Account',
  DECLINED: 'Declined',
  EXPIRED: 'Expired',
  LAST_30_DAYS: 'last30days',
  BEYOND_30_DAYS: 'beyond30days',
};

export const URLS = {
  PDS_URL:
    'https://www.einsure.com.au/wb/public/openCurrentPolicyDocument/POL268LIF/$File/POL268LIF.pdf',
  YOUR_DUTY_EXCLUSION_PRIVACY_NOTICE_URL: `${window.location.origin}/information-and-duty`,
  MORE_INFO_URL: 'https://www.allianz.com.au/misrepresentation-life',
  CONTACT_US_PHONE_NUMBER: '13 1000',
  CONSENT_PHONE_NUMBER: '1300203055',
  CONTACT_US_PHONE_URL: 'tel:131000',
  CONSENT_PHONE_URL: 'tel:1300203055',
  ALLIANZ_WEBSITE_URL: 'https://www.allianz.com.au',
  ADDITIONAL_POLICY_OWNER_FORM_URL:
    'https://www.einsure.com.au/wb/public/openCurrentPolicyDocument/OTH186LIF/$FILE/OTH186LIF.pdf',
  RECORD_OF_ANSWERS_URL: 'https://www.allianz.com.au/#TODO',
  COMPLAINTS_PROCESS_URL: 'https://www.allianz.com.au/contact-us/dispute-resolution.html',
  ALLIANZ_HOMEPAGE: 'https://www.allianz.com.au/',
  ALLIANZ_LIFE_HOMEPAGE: 'https://www.allianz.com.au/life-insurance.html',
  POLICY_OUTCOME:
    'https://www.allianz.com.au/my-allianz/policy-information/policy-documents.html#life',
  POLICY_EXCLUSION: 'https://www.elifeinsure.com.au/information-and-duty',
  MISREPRESENTATION:
    'https://www.allianz.com.au/my-allianz/policy-information/misrepresentation-life.html',
  GIFT_CARD_TERM_CONDITIONS_URL:
    'https://www.allianz.com.au/life-insurance/gift-card-comp-2026.html',
  GIFT_CARD_TERM_CONDITIONS: 'Terms & Conditions',
  CODES_AND_STANDARDS: 'https://www.allianz.com.au/about-us/insurance-codes-and-standards.html',
};

export const ONLINE_URLS = {
  GETTING_STARTED_TARGET_MARKET_DETERMINATION:
    'https://www.allianz.com.au/my-allianz/policy-information/tmds.html#life',
  GETTING_STARTED_PRIVACY_POLICY: 'https://www.allianz.com.au/privacy-policy.html',
  GETTING_STARTED_PRIVACY_NOTICE: 'https://www.elifeinsure.com.au/information-and-duty#privacy',
  GETTING_STARTED_YOUR_DUTY: 'https://www.elifeinsure.com.au/information-and-duty',
};

export const CONTACT_CENTER_URLS = {
  GETTING_STARTED_PRIVACY_POLICY: 'https://www.allianz.com.au/privacy-policy.html',
};

export const onlineRetrieveContent = {
  RETRIEVE_LIFE_PPLICATION: 'Retrieve your Life Insurance application',
  ENTER_DETAILS: 'Please enter the following details:',
  APPLICATION_NOT_FOUND:
    'No matching application found. Re-enter your details and try again. Or call our friendly Life Insurance Specialists on',
  RETRIEVE_APPLICATION_BUTTON: 'RETRIEVE MY APPLICATION',
};

export const TRACKIFY_EVENT = {
  OTP_VALIDATION_MODAL: 'otp-validation-modal',
  SEND_EMAIL_PAYMENT: 'online-send-email-payment-details',
  SEND_EMAIL_POLICY_OUTCOME: 'online-send-email-policy-outcome',
  SEND_EMAIL_POLICY_SUMMARY: 'send-email-quote-summary',
  SEND_OTP_MODAL: 'send-otp-modal',
  SEND_EMAIL_REVIEW_APPLICATION: 'send-email-review-application',
  SEND_EMAIL_SUCCESS: 'send-email-success',
  RETRIEVE_QUOTE_ONLINE: 'online-retrieve-quote',
  RETRIEVE_SEND_OTP_MODAL: 'retrieve-send-otp-modal',
  RETRIEVE_OTP_VALIDATION_MODAL: 'retrieve-otp-validation-modal',
  RETRIEVE_QUOTE_CC: 'cc-retrieve-quote',
  TRACKIFY_APP_NAME: 'Lisa Term Life',
  TRACKIFY_PAGE_ID: 'LISA',
  CC_SEND_EMAIL_POLICY_OUTCOME: 'cc-send-email-policy-outcome',
  CC_SEND_EMAIL_PAYMENT: 'cc-send-email-payment-details',
  SAVE_CONFIRMATION: 'save-confirmation',
  CREDIT_CARD: 'creditCard',
  BANK_ACCOUNT: 'bankAccount',
};
